import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";
import api from "../client";
const token = localStorage.getItem("token");
const refreshToken = localStorage.getItem("refreshToken");

var isValidToken = false;
var username = "";
var fullname = "";
let permissions = [];

if (token) {
  var decodedToken = jwtDecode(token);
  if (decodedToken.exp * 1000 > Date.now()) {
    isValidToken = true;
    username =
      decodedToken[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"
      ];
    fullname =
      decodedToken[
        "http://schemas.xmlsoap.org/ws/2005/05/identity/claims/givenname"
      ];
    permissions = decodedToken["permission"];
  } else {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
  }
}

export const loginUser = createAsyncThunk(
  "identity/auth/signin",
  async (userData, thunkAPI) => {
    return api.post("identity/auth/signin", userData).then(function (response) {
      return response.data;
    });
  },
);
export const registerUser = createAsyncThunk(
  "User/register",
  async (user, thunkAPI) => {
    const url = "auth/Register";
    return api.post(url, user).then(function (response) {
      return response.data;
    });
  },
);
export const profile = createAsyncThunk("Auth/Profile", async (thunkAPI) => {
  const url = "identity/auth/me";
  return api.get(url).then(function (response) {
    return response.data;
  });
});
export const refreshAccessToken = createAsyncThunk(
  "auth/refreshToken",
  async (_, thunkAPI) => {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) {
      return thunkAPI.rejectWithValue("No refresh token available");
    }
    return api.post("identity/auth/refresh", { refreshToken }).then(function (response) {
      return response.data;
    });
  },
);

export const logoutUser = createAsyncThunk(
  "auth/logout",
  async (userData, thunkAPI) => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
  },
);

const initialState = isValidToken
  ? {
      isLoading: false,
      isLoggedIn: true,
      username,
      fullname,
      permissions,
      error: null,
    }
  : {
      isLoading: false,
      isLoggedIn: false,
      username: null,
      fullname: null,
      user: null,
      message: null,
      permissions: [],
      error: null,
    };

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state, action) => {
        state.isLoading = true;
        state.isLoggedIn = false;
        state.error = null;
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.succeeded) {
          state.isLoggedIn = true;
          var token = action.payload.data.access_token;
          var refreshToken = action.payload.data.refresh_token;
          localStorage.setItem("token", token);
          localStorage.setItem("refreshToken", refreshToken);
          var decodedToken = jwtDecode(token);
          state.permissions = decodedToken["permission"];
          console.log("Permissions:", state.permissions);
        } else {
          state.isLoggedIn = false;
          state.error = action.payload.message;
        }
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.isLoading = false;
        state.isLoggedIn = false;
        state.error = action.error.message;
      })
      .addCase(registerUser.pending, (state, action) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.succeeded) {
        } else {
          state.error = action.payload.message;
        }
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      })
      .addCase(logoutUser.fulfilled, (state, action) => {
        state.isLoggedIn = false;
        state.message = "Logout successfully.";
      })
      .addCase(profile.fulfilled, (state, action) => {
        state.user = action.payload.data;
        state.fullname = action.payload.data.fullName;
      })
      .addCase(profile.rejected, (state, action) => {
        state.user = null;
      })
      .addCase(refreshAccessToken.fulfilled, (state, action) => {
        if (action.payload.succeeded) {
          var token = action.payload.data.access_token;
          var refreshToken = action.payload.data.refresh_token;
          localStorage.setItem("token", token);
          localStorage.setItem("refreshToken", refreshToken);
          state.isLoggedIn = true;
          var decodedToken = jwtDecode(token);
          state.permissions = decodedToken["permission"];
        } else {
          state.isLoggedIn = false;
          state.error = action.payload.message;
          localStorage.removeItem("token");
          localStorage.removeItem("refreshToken");
        }
      })
      .addCase(refreshAccessToken.rejected, (state, action) => {
        state.isLoggedIn = false;
        state.error = action.payload || "Token refresh failed";
        localStorage.removeItem("token");
        localStorage.removeItem("refreshToken");
      });
  },
});

export default slice.reducer;
